import { logDebug } from '../../../../log.js';
import type { AcpClientOptions } from '../acp-client.js';
import type { AcpSessionContext } from '../acp-session-context.js';
import { createStderrCapture } from '../agent-stderr-capture.js';

export function createCursorAcpSessionContext(options: {
  cwd: string;
  mcpServers?: unknown[];
  persistedAcpSessionId?: string | null;
  backendAgentType?: string | null;
  agentConfig?: Record<string, unknown> | null;
  getActiveConfigOptions?: AcpClientOptions['getActiveConfigOptions'];
  onAcpSessionEstablished?: AcpClientOptions['onAcpSessionEstablished'];
  onAcpConfigOptionsUpdated?: AcpClientOptions['onAcpConfigOptionsUpdated'];
  onFileChange?: AcpClientOptions['onFileChange'];
  stderrCapture: ReturnType<typeof createStderrCapture>;
}): AcpSessionContext {
  const suppressLoadReplayRef = { value: false };
  return {
    cwd: options.cwd,
    onFileChange: options.onFileChange,
    mcpServers: options.mcpServers ?? [],
    persistedAcpSessionId: options.persistedAcpSessionId,
    agentLabel: 'Cursor',
    suppressLoadReplay: suppressLoadReplayRef,
    backendAgentType: options.backendAgentType ?? null,
    agentConfig: options.agentConfig,
    getActiveConfigOptions: options.getActiveConfigOptions,
    onAcpSessionEstablished: options.onAcpSessionEstablished,
    onAcpConfigOptionsUpdated: options.onAcpConfigOptionsUpdated,
    logDebug,
    getStderrText: () => options.stderrCapture.getText(),
  };
}
